import React from "react";
import "./contact.css";
import Separator from "../../common/separator";
import PersonalContact from "../../common/personal-contact";

function Contact() {
  return (
    <div className="contact">
      <Separator />
      <label className="section-title">Contact</label>
      <div className="contact-container">
        <div className="contact-card">
          <div className="contact-header">
            <h3 className="contact-title">Let's Connect!</h3>
            <p className="contact-subtitle">
              I'm always interested in new opportunities and exciting projects. 
              Feel free to reach out if you'd like to discuss potential collaborations.
            </p>
          </div>
          <div className="contact-info">
            <PersonalContact />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
